import React from "react";
import Modal from "../modal-new";
import ImageRadio from "../inputs/image-radio";
import { isPullActiveCoach } from "../../utils/user-helpers";

export const EditWidgetInfoModal = ({
  iconsRadios,
  widgetDescription,
  widgetIcon,
  widgetName,
  handleInputChange,
  handleSubmit,
  isOpen,
  onClose,
  validationSubmit,
  WidgetTogglePull,
  WidgetTogglePush,
  userToRequest,
  pullPermission,
  pushPermission,
}) => {
  if (!isOpen) {
    return null;
  }
  return (
    <Modal
      className={"edit-widget-modal Widget-Modal"}
      title="Edit Widget Information"
      onClose={onClose}
    >
      <div className="body">
        <div>
          <div className="input-group">
            <label> Widget name </label>
            <input
              maxLength="30"
              name="name-mobile"
              className="text-input"
              placeholder={`Enter Name`}
              value={widgetName}
              onChange={handleInputChange}
              sz="large"
            />
          </div>

          <div className="input-group">
            <label> Widget description </label>
            <input
              maxLength="60"
              name="description-mobile"
              className="text-input"
              placeholder={`Enter description here..`}
              value={widgetDescription}
              onChange={handleInputChange}
              sz="large"
            />
          </div>

          <div className="input-group">
            <ImageRadio
              label="Widget icon"
              name="icon-mobile"
              currentValue={widgetIcon}
              radios={iconsRadios}
              onChange={handleInputChange}
              isManager={true}
            />
          </div>

          <div className="input-group">
            <label>User type access</label>
            {isPullActiveCoach(userToRequest) && (
              <WidgetTogglePull permission={pullPermission} />
            )}
            {userToRequest.pushAccountInfo && (
              <WidgetTogglePush permission={pushPermission} />
            )}
          </div>
        </div>
      </div>

      <footer>
        <button
          data-button-type="secondary"
          data-action="cancel"
          onClick={onClose}
        >
          Cancel
        </button>
        <button
          data-button-type="primary"
          onClick={(e) => {
            handleSubmit(e);
            onClose();
          }}
          disabled={!validationSubmit()}
        >
          Save
        </button>
      </footer>
    </Modal>
  );
};
